module.exports = __webpack_public_path__ + "img/8.d148d4f9.png";